const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: [],
    listaCidade: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PARCEIRO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PARCEIRO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'PARCEIRO_LISTADO':
            return {
                ...state, 
                lista: action.payload.data,
                listaSelect: action.payload.data.map(item => ({
                    id: item.id,
                    valor: item.razao_social,
                    solicita_silo: item.solicita_silo,
                    solicita_lote: item.solicita_lote
                }))
            };

        case 'PARCEIRO_CIDADE_LISTADO':            
			return { ...state, listaCidade: action.payload.data };

        default:
            return state;
    }
}
